import React, { useState, useEffect, useRef, useCallback } from "react";
import { Route, NavLink } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Cookies from "js-cookie";
import {
  HiOutlineHome,
  HiOutlineClipboardList,
  HiOutlineDocumentText,
  HiOutlineCheckCircle,
  HiOutlineShoppingCart,
  HiOutlineArchive,
  HiOutlineXCircle,
  HiOutlineCash,
  HiOutlineBeaker,
  HiOutlineSupport,
  HiOutlineUserCircle,
  HiOutlineBell,
  HiOutlineLogout,
  HiOutlineMenuAlt2,
  HiOutlineX,
  HiOutlineChevronDown,
  HiOutlineTranslate,
} from "react-icons/hi";

import axiosInstance from "../../api/axiosInstance";
import { apiurl } from "../../App";
import i18n from "../../i18n/i18n";
import { decryptData, encryptData } from "../Crypto_Helpers/cryptoHelper";
import { initEncryptionSession } from "../../encryptionSession";

import DashboardMaster from "../Dashboard/DashboardMaster";
import CancelledDashboard from "../CancelledHistory/CancelledDashboard";
import ManageServiceMaster from "../ManageService/ManageServiceMaster";
import MediaUploadsMaster from "../MediaUploads/MediaUploadsMaster";
import PaymentReceived from "../PaymentReceived/PaymentReceived";
import ProfileComp from "../Profile/ProfileComp";
import TotalMaster from "../TotalOrders/TotalMaster";
import CompletedPrescriptions from "../TotalOrders/CompletedPrescriptions";
import RevenueMaster from "../Revenue/RevenueMaster";
import DeliveryMaster from "../DeliveryTracking/TrackingMaster";
import MedicineMaster from "../MedicineRate/MedicineMaster";
import PrescriptionMasterview from "../PrescriptionEntry/Dashboardheader";
import TotalPrescription from "../PrescriptionEntry/TotalPrescription";
import PendingQuotesTable from "../PendingQuotes/PendingQuotesTable";
import PendingApprovalsTable from "../PendingApprovals/PendingApprovalsTable";
import PendingOrdersTable from "../PendingOrders/PendingOrdersTable";
import Stepper from "../StepperStatus/Status";
import CheckCall from "../CheckCall";
import TicketMaster from "../Ticketing/TicketMaster";
import RevenueChart from "../Revenue/RevenueChart";
import RevenueSettlement from "../Revenue/RevenueSettlement";
import Logo from "../../assets/images/Avelator_Logo.png";
import "./Drawerpage.css";

i18n.changeLanguage(localStorage.pharmacy_language);

const ALL_MENU_ITEMS = [
  { key: "dashboard", nameKey: "home", icon: HiOutlineHome, path: "dashboard" },
  { key: "prescription", nameKey: "total_prescriptions", icon: HiOutlineClipboardList, path: "prescription" },
  { key: "pending_quotes", nameKey: "pending_quotes", icon: HiOutlineDocumentText, path: "pending_quotes" },
  { key: "pending_approvals", nameKey: "pending_approvals", icon: HiOutlineCheckCircle, path: "pending_approvals" },
  { key: "pending_orders", nameKey: "pending_orders", icon: HiOutlineShoppingCart, path: "pending_orders" },
  { key: "totalorders", nameKey: "completed_prescriptions", icon: HiOutlineArchive, path: "totalorders" },
  { key: "cancelorders", nameKey: "canceled_quotes", icon: HiOutlineXCircle, path: "cancelorders" },
  { key: "revenue", nameKey: "revenue", icon: HiOutlineCash, path: "revenue" },
  { key: "medicine", nameKey: "manage_medicine", icon: HiOutlineBeaker, path: "medicine" },
  { key: "ticket", nameKey: "ticketing", icon: HiOutlineSupport, path: "ticket" },
  { key: "profile", nameKey: "profile", icon: HiOutlineUserCircle, path: "profile" },
];

const MiniDrawer = ({ match, history }) => {
  const { t, i18n: i18nInstance } = useTranslation();
  const isArabic = i18nInstance.language === "ar";

  const [isSidebarOpen, setSidebarOpen] = useState(true);
  const [profileData, setProfileData] = useState([]);
  const [imageUrl, setImageUrl] = useState(
    Cookies.get("profilePath") || localStorage.getItem("profilePath") || ""
  );
  const [vendorName, setVendorName] = useState(
    Cookies.get("User_name") || localStorage.getItem("User_name") || ""
  );
  const [notificationList, setNotificationList] = useState([]);
  const [profileMenuOpen, setProfileMenuOpen] = useState(false);

  const notifyIntervalRef = useRef(null);
  const contractIntervalRef = useRef(null);

  const location = window.location.href;

  const getProfile = useCallback(async () => {
    try {
      const aesKey = await initEncryptionSession();
      const pharmId =
        Cookies.get("pharmacy_id") ||
        Cookies.get("vendorId") ||
        localStorage.getItem("pharmacy_id") ||
        localStorage.getItem("vendorId") ||
        "0";

      const data = { pharm_id: pharmId };
      let requestData = data;
      if (aesKey) {
        try {
          const encrypted = await encryptData(data, aesKey);
          requestData = { objects: encrypted };
        } catch (e) {
          requestData = data;
        }
      }

      const response = await axiosInstance.post(apiurl + "pharmacy/getPharmProfile", requestData);
      let list = [];
      if (response && response.data) {
        if (Array.isArray(response.data.data)) {
          list = response.data.data;
        } else if (typeof response.data.data === "string" && aesKey) {
          try {
            list = await decryptData(response.data.data, aesKey);
          } catch (e) {
            list = [];
          }
        }
      }

      if (Array.isArray(list) && list.length > 0) {
        const item = list[0];
        const avatarUrl = item.vendor_filename || item.vendor_profile_path || "";
        const vName = item.vendor_name || item.contact_person || Cookies.get("User_name") || "";
        if (avatarUrl) {
          Cookies.set("profilePath", avatarUrl);
          localStorage.setItem("profilePath", avatarUrl);
        }
        if (vName) {
          Cookies.set("User_name", vName);
          localStorage.setItem("User_name", vName);
          localStorage.setItem("pharmacy_name", vName);
        }
        if (item.clinic_name) localStorage.setItem("clinic_name", item.clinic_name);
        if (item.vendor_address) localStorage.setItem("pharmacy_address", item.vendor_address);
        if (item.vendor_phone || item.vendor_contact_mobile) {
          localStorage.setItem("pharmacy_phone", item.vendor_phone || item.vendor_contact_mobile);
        }
        if (item.vendor_email || item.person_email) {
          localStorage.setItem("pharmacy_email", item.vendor_email || item.person_email);
        }
        setProfileData(list);
        setImageUrl(avatarUrl);
        setVendorName(vName);
      }
    } catch (error) {
      console.error("Drawerpage getProfile error:", error);
    }
  }, []);

  const getNotificationList = useCallback(() => {
    if (!Cookies.get("pharmacy_id")) {
      window.localStorage.clear();
      window.location.assign("/?/pharmacymodule");
      return;
    }
    axiosInstance({
      method: "POST",
      url: apiurl + "admin/notification_list",
      data: { vendor_id: Cookies.get("pharmacy_id") || "2" },
    })
      .then((response) => {
        setNotificationList((prev) => {
          const next = response.data.data;
          return JSON.stringify(next) !== JSON.stringify(prev) ? next : prev;
        });
      })
      .catch((error) => console.error(JSON.stringify(error)));
  }, []);

  const getContractDetail = useCallback(() => {
    if (!Cookies.get("pharmacy_id")) return;
    axiosInstance({
      method: "POST",
      url: apiurl + "admin/checkContractValid",
      data: { vendor_id: Cookies.get("pharmacy_id") || "2" },
    })
      .then((response) => {
        if (response.data.data[0].ErrorCode != "9999") {
          window.localStorage.clear();
          window.location.assign("/?/pharmacymodule");
        }
      })
      .catch((error) => console.error(JSON.stringify(error)));
  }, []);

  useEffect(() => {
    getProfile();
    getNotificationList();
    getContractDetail();

    notifyIntervalRef.current = setInterval(getNotificationList, 10000);
    contractIntervalRef.current = setInterval(getContractDetail, 600000);

    return () => {
      clearInterval(notifyIntervalRef.current);
      clearInterval(contractIntervalRef.current);
    };
  }, []);

  const handleNotificationOpen = () => history.push("/Home/notification");

  const handleLogout = () => {
    import("js-cookie").then(({ default: C }) => {
      Object.keys(C.get()).forEach((k) => C.remove(k));
    });
    localStorage.clear();
    window.location.replace("/pharmacymodule/?/");
  };

  const handleChangeLanguage = () => {
    const next = localStorage.pharmacy_language === "ar" ? "en" : "ar";
    localStorage.pharmacy_language = next;
    i18nInstance.changeLanguage(next);
    window.location.reload();
  };

  return (
    <div className="min-h-screen bg-gray-50 flex">
      {/* Sidebar */}
      <aside
        className={`fixed top-0 left-0 h-full bg-white border-r border-gray-200 z-50 transition-all duration-300 ${
          isSidebarOpen ? "w-64" : "w-20"
        }`}
      >
        <div className="h-20 flex items-center justify-center border-b border-gray-100 px-4">
          {isSidebarOpen ? (
            <img
              src={imageUrl && imageUrl.trim() !== "" ? imageUrl : Logo}
              alt="Logo"
              className="h-14 w-auto object-contain py-2 rounded-lg"
            />
          ) : (
            <div className="w-8 h-8 bg-teal-600 rounded flex items-center justify-center text-white font-bold">
              P
            </div>
          )}
        </div>

        <nav className="p-4 space-y-2">
          {ALL_MENU_ITEMS.map((item) => {
            const isActive = location.endsWith(item.path);
            return (
              <NavLink
                key={item.key}
                to={`/Home/${item.path}`}
                className={`w-full flex items-center gap-3 p-3 rounded-xl transition-all no-underline ${
                  isActive ? "bg-teal-50 text-teal-700 font-semibold" : "text-gray-500 hover:bg-gray-50 hover:text-gray-700"
                }`}
              >
                <item.icon size={22} className={`shrink-0 ${isActive ? "text-teal-600" : ""}`} />
                {isSidebarOpen && <span className="text-sm">{t(item.nameKey)}</span>}
                {isActive && isSidebarOpen && <div className="ml-auto w-1.5 h-1.5 bg-teal-600 rounded-full" />}
              </NavLink>
            );
          })}
        </nav>

        <div className="absolute bottom-4 left-4 right-4">
          <button
            onClick={handleLogout}
            className="w-full flex items-center gap-3 p-3 text-red-500 hover:bg-red-50 rounded-xl transition-all"
          >
            <HiOutlineLogout size={22} className="shrink-0" />
            {isSidebarOpen && <span className="text-sm font-medium">{t("logout")}</span>}
          </button>
        </div>
      </aside>

      {/* Main content */}
      <main className={`flex-1 transition-all duration-300 ${isSidebarOpen ? "ml-64" : "ml-20"}`}>
        <header className="h-20 bg-white border-b border-gray-200 flex items-center justify-between px-6 sm:px-8 sticky top-0 z-40">
          <button
            onClick={() => setSidebarOpen(!isSidebarOpen)}
            className="p-2 rounded-lg hover:bg-gray-100 text-gray-500"
          >
            {isSidebarOpen ? <HiOutlineX size={22} /> : <HiOutlineMenuAlt2 size={22} />}
          </button>

          <div className="flex items-center gap-3 sm:gap-5">
            <button
              onClick={handleChangeLanguage}
              className="p-2 rounded-full hover:bg-gray-100 text-gray-500 transition-colors"
              title={isArabic ? "English" : "العربية"}
            >
              <HiOutlineTranslate size={20} />
            </button>

            <button
              onClick={handleNotificationOpen}
              className="relative p-2 rounded-full hover:bg-gray-100 text-gray-500 transition-colors"
              title={t("home")}
            >
              <HiOutlineBell size={22} />
              {notificationList.length > 0 && (
                <span className="absolute top-1.5 right-1.5 w-2 h-2 bg-red-500 rounded-full" />
              )}
            </button>

            <div className="relative">
              <button
                className="flex items-center gap-3"
                onClick={() => setProfileMenuOpen((v) => !v)}
              >
                <div className="w-11 h-11 rounded-full bg-teal-100 border-2 border-white shadow-sm flex items-center justify-center text-teal-700 font-bold overflow-hidden shrink-0">
                  {imageUrl ? (
                    <img src={imageUrl} alt="Profile" className="w-full h-full object-cover" />
                  ) : (
                    vendorName?.charAt(0) || "P"
                  )}
                </div>
                <div className="text-left hidden sm:block">
                  <p className="text-sm font-bold text-gray-900 leading-none">{vendorName || "Pharmacy"}</p>
                  <p className="text-xs text-gray-500 mt-1.5">
                    {profileData?.[0]?.person_email || ""}
                  </p>
                </div>
                <HiOutlineChevronDown className="text-gray-400 hidden sm:block" size={16} />
              </button>

              {profileMenuOpen && (
                <div className="absolute right-0 mt-2 w-48 bg-white rounded-xl shadow-lg border border-gray-100 py-2 z-50">
                  <NavLink
                    to="/Home/profile"
                    className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-50 no-underline"
                    onClick={() => setProfileMenuOpen(false)}
                  >
                    {t("profile")}
                  </NavLink>
                  <NavLink
                    to="/PrivacyPolicy"
                    target="_blank"
                    className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-50 no-underline"
                    onClick={() => setProfileMenuOpen(false)}
                  >
                    {t("privacy_policy")}
                  </NavLink>
                  <div className="border-t border-gray-100 my-1" />
                  <button
                    onClick={handleLogout}
                    className="w-full text-left px-4 py-2 text-sm text-red-500 hover:bg-red-50"
                  >
                    {t("logout")}
                  </button>
                </div>
              )}
            </div>
          </div>
        </header>

        <div className="p-4 sm:p-6 lg:p-8">
          <Route path={`${match.path}/dashboard`} component={DashboardMaster} />
          <Route path={`${match.path}/cancelorders`} component={CancelledDashboard} />
          <Route path={`${match.path}/manageservice`} component={ManageServiceMaster} />
          <Route path={`${match.path}/mediaupload`} component={MediaUploadsMaster} />
          <Route path={`${match.path}/paymentReceive`} component={PaymentReceived} />
          <Route
            path={`${match.path}/profile`}
            render={(props) => (
              <ProfileComp {...props} t={t} i18n={i18nInstance} getProfile={getProfile} />
            )}
          />
          <Route path={`${match.path}/totalorders`} component={CompletedPrescriptions} />
          <Route path={`${match.path}/revenue`} component={RevenueChart} />
          <Route
            path={`${match.path}/revenueChart/revenue/:startDate/:endDate/:id/:pageN`}
            component={RevenueMaster}
          />
          <Route
            path={`${match.path}/revenueChart/settlement/:startDate/:endDate/:id`}
            component={RevenueSettlement}
          />
          <Route
            path={`${match.path}/revenueChart/medlist/:startDate/:endDate/:id`}
            component={RevenueMaster}
          />
          <Route path={`${match.path}/tracking`} component={DeliveryMaster} />
          <Route path={`${match.path}/medicine`} component={TotalMaster} />
          <Route path={`${match.path}/prescription`} component={PrescriptionMasterview} />
          <Route path={`${match.path}/totalprescription`} component={TotalPrescription} />
          <Route path={`${match.path}/pending_quotes`} component={PendingQuotesTable} />
          <Route path={`${match.path}/pending_approvals`} component={PendingApprovalsTable} />
          <Route path={`${match.path}/pending_orders`} component={PendingOrdersTable} />
          <Route path={`${match.path}/status`} component={Stepper} />
          <Route path={`${match.path}/checkData`} component={CheckCall} />
          <Route path={`${match.path}/ticket`} component={TicketMaster} exact />
        </div>
      </main>
    </div>
  );
};

export default MiniDrawer;
